<template>
    <gofix-card class="mb-0 heig-frame-child" fullContent>
        <gofix-default-table :settings="tableConfig" :table-items="tableItems" :tbody-tr-class="rowClass" @load-items="getTableData" @delete-items="deleteItems" @new-item="newItem" @row-click="detailItem" @get-selected="openModalCreateRWO" @export="exportCSV" @exportCaseNLT="showModalExportNLT" ref="gofixTable">
            <template slot="gofix_table:reported_time" slot-scope="row">
                {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:deadline" slot-scope="row">
                {{row.item.deadline | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:created_at" slot-scope="row">
                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <!-- <template slot="gofix_table:repeated_feedback" slot-scope="row">
                {{(row.item.repeated_feedback && row.item.repeated_feedback.length) ? (row.item.repeated_feedback.length - 1) : 0}}
            </template> -->
            <template slot="gofix_table:order_number" slot-scope="row">
                <span class="checklistLink" @click="gotoOrderNumber(row.item)"> {{ row.item.order_number }} </span>
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-RaiseACase" title="Create RWO" hide-footer :centered="true" :no-close-on-esc="true" v-model="modals.order.open">
            <b-form class="formV2">
                <b-row>
                    <b-col md="12">
                        <gofix-form-supplier label="Supplier" :contract-id="ClientContractID ? ClientContractID.id:null" :service-category-id="modals.order.caseSelected ? modals.order.caseSelected.service_category_id : null" :property-id="modals.order.caseSelected ? modals.order.caseSelected.location_id : null" :filterable="false" @change="selectSupplier" v-model="modals.order.data.supplier">
                        </gofix-form-supplier>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown label="FM Staff" vLabel="user_name" :filterable="false" @search="searchUser" v-model="modals.order.data.officer_in_charge_id" :options="modals.order.fmStaffData">
                            <template #gofixInput:dropdown:option="option">
                                {{option.user_name}} - {{option.role_name}}
                            </template>
                            <template #gofixInput:dropdown:selected-option="option">
                                {{option.user_name}} - {{option.role_name}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="createRWO" :loading="modals.order.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="Select contratual reported date (export)" hide-footer :centered="true" v-model="modals.exportNLT.open">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.exportNLT.data.start_date"
                            label="Start Date"
                            @change="updateDate"
                            >
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.exportNLT.data.end_date"
                            label="End Date"
                            :min-date="modals.exportNLT.data.min_end_date"
                            :max-date="modals.exportNLT.data.max_end_date"
                            >
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-checkbox v-model="modals.exportNLT.data.include_email" class="ml-0 mt-20 mb-20 d-inline-block"><span>Include email service level performance calculation</span></b-form-checkbox>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.exportNLT.loading" @click="exportCaseNLT" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Export Data" hide-footer :centered="true" v-model="modals.exportNLT.open_process" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">{{modals.exportNLT.process}}</span>
                </b-progress-bar>
            </b-progress>
          </b-modal>
          <b-modal :no-close-on-backdrop="true" id="modal-Export-NLT-Message" hide-footer hide-header :centered="true" v-model="modals.exportNLTMessage.open">
            <div class="center">
                The report is being processed by system. <br/>You will receive a link to download the report via email once it is ready.<br/><br/>
                
            </div>
            <b-button-group class="d-block text-right">
                <gofix-button label="CLOSE"  @click="modals.exportNLTMessage.open = false" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>

import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'case-management',
    props:["case_status"],
    data() {
        let filter = JSON.parse(JSON.stringify(filters['case_management']));
        if(this.case_status){
            filter.status.value = this.case_status;
        }
        return {
            tableConfig: {
                name: 'case-management',
                controls: {
                    create: this.$checkRole(this.$accessModule.case_management, 'create'),
                    delete: this.$checkRole(this.$accessModule.case_management, 'delete'),
                    sendSelected: this.$checkRole(this.$accessModule.order, 'create'),
                    sendSelectedText: "Create RWO",
                    tableImport: false,
                    tableExport: true,
                    tableExportCaseNLT: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            modals: {
                order: {
                    open: false,
                    loading: false,
                    data: {
                        supplier: null,
                        supplier_id: null,
                        officer_in_charge_id: null,
                    },
                    ids: [],
                    caseSelected: null,
                    supplierData: [],
                    supplierDataTimeOut: null,
                    fmStaffData: [],
                    fmStaffDataTimeOut: null,
                    fmStaffDataLoading: false
                },
                exportNLT : {
                    open: false,
                    loading: false,
                    process: 'Creating file export',
                    open_process: false,
                    data: {
                        start_date: null,
                        end_date: null,
                        include_email: false,
                        min_end_date: null,
                        max_end_date: null,
                    }
                },
                exportNLTMessage : {
                    open: false
                }
            }
        }
    },
    watch: {
        "currentRoles": function(val, old) {
            this.tableConfig.controls = {
                create: this.$checkRole(this.$accessModule.case_management, 'create'),
                delete: this.$checkRole(this.$accessModule.case_management, 'delete'),
                sendSelected: this.$checkRole(this.$accessModule.order, 'create'),
                sendSelectedText: "Create RWO",
                tableImport: false,
                tableExportCaseNLT: this.ClientContractID && this.ClientContractID.case_settings && this.ClientContractID.case_settings.is_use_nlt_case_module && this.hideRoleExportCaseNLT() ? true : false,
                tableExport: this.ClientContractID && this.ClientContractID.case_settings && this.ClientContractID.case_settings.is_use_nlt_case_module ? false : true
            }
        },
        ClientContractID: function(val) {
            this.tableConfig.controls = {
                create: this.$checkRole(this.$accessModule.case_management, 'create'),
                delete: this.$checkRole(this.$accessModule.case_management, 'delete'),
                sendSelected: this.$checkRole(this.$accessModule.order, 'create'),
                sendSelectedText: "Create RWO",
                tableImport: false,
                tableExportCaseNLT: val && val.case_settings && val.case_settings.is_use_nlt_case_module && this.hideRoleExportCaseNLT() ? true : false,
                tableExport: val && val.case_settings && val.case_settings.is_use_nlt_case_module ? false : true,
            }
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID',
            currentRoles: 'AuthController/roles',
        })
    },
    created() {},
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if(this.ClientContractID && this.ClientContractID.case_settings) {
                tableRequest.filter.is_case_nlt = false;
                if(this.ClientContractID.case_settings.is_use_nlt_case_module) tableRequest.filter.is_case_nlt = true;
            }
            if(this.case_status && (this.case_status == 'Opening' || this.case_status == 'Closed') &&
                (
                    (Array.isArray(tableRequest.filter.status.value) && !tableRequest.filter.status.value.length) ||
                    (!Array.isArray(tableRequest.filter.status.value) && !tableRequest.filter.status.value)
                )
            ) {
                tableRequest.filter.status.value = this.case_status;
            }
            await this.$store.dispatch("CaseManagementController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case management", "danger");
                    reject();
                })
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("CaseManagementController/deteleItem", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'case'))
                })
                .catch(err => {
                    reject(err);
                });
        },
        async newItem() {
            return this.$router.push({
                name: 'case-detail',
                params: {
                    id: 0
                }
            })
        },
        async detailItem(item, event) {
            if (event.target.children[0] && event.target.children[0].className.includes("checklistLink")) {
                if (item.work_order_id) {
                    this.$router.push(`/v2/orders/${item.work_order_id}`);
                }
                return;
            }
            return this.$router.push({
                name: 'case-detail',
                params: {
                    id: item.id
                }
            })
        },
        gotoOrderNumber(item) {
            if (item.work_order_id) {
                this.$router.push(`/v2/orders/${item.work_order_id}`);
            }
        },
        /*----------------------------------------*/

        /*------ Component event  (Load + config data)-----------------*/
        searchSupplier(search, loading) {
            this.modals.order.supplierData = []
            loading(true);
            if (this.modals.order.supplierDataTimeOut) {
                clearTimeout(this.modals.order.supplierDataTimeOut);
                this.modals.order.supplierDataTimeOut = null;
            }
            this.modals.order.supplierDataTimeOut = setTimeout(() => {
                try {
                    this.getSupplier({ contract_id: this.ClientContractID.id, name: search }, 100);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        getSupplier(filter = {}, limit = 100) {
            filter['is_supplier'] = true
            this.$store.dispatch('OrganizationController/searchItemsInUser', { filter: filter, limit: limit })
                .then(response => {
                    this.modals.order.supplierData = response.data.data.items
                })
        },
        selectSupplier(item) {
            if (item) {
                this.modals.order.data.supplier_id = item.id
                /*this.modals.order.fmStaffDataLoading = true;
                this.getUser({ organisation_id: item.id });*/
            }
        },
        getUser(contract_id, property_id, search = null, limit = 100) {
            this.$store.dispatch("v2UserController/getAccessFmUsers", {
                    contract_id: contract_id,
                    property_id: property_id,
                    section_name: ["Case Management"],
                    module_name: ["Case"],
                    //group_user:true,
                    filter: { name: search || null }
                })
                .then(response => {
                    this.modals.order.fmStaffData = response.items;
                    this.modals.order.fmStaffDataLoading = false;
                    if (!search) {
                        let activeUser = this.modals.order.fmStaffData.find(element => element.user_id === this.modals.order.data.officer_in_charge_id.user_id);
                        this.modals.order.data.officer_in_charge_id.role_name = activeUser.role_name;
                    }
                })
                .catch(err => { this.modals.order.fmStaffDataLoading = false; })
        },
        searchUser(search, loading) {
            loading(true);
            this.modals.order.caseSelected = this.tableItems.find(element => element.id === this.modals.order.ids[0]);
            if (this.modals.order.fmStaffDataTimeOut) {
                clearTimeout(this.modals.order.fmStaffDataTimeOut);
                this.modals.order.fmStaffDataTimeOut = null;
            }
            this.modals.order.fmStaffDataTimeOut = setTimeout(() => {
                this.getUser(this.modals.order.caseSelected.client_contract_id, this.modals.order.caseSelected.location_id, search);
                loading(false);
            }, 300);
        },
        openModalCreateRWO(ids, filter) {
            if (!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Please select a contract before create RWO.", "danger");
            }

            if (ids.length === 0 || ids.length > 1) {
                return this.$alertNotification("Please select only 1 item to create RWO.", "danger");
            }

            this.modals.order.ids = ids;
            this.modals.order.data = {
                supplier: null,
                supplier_id: null,
                officer_in_charge_id: null,
            };

            //Get case
            this.modals.order.caseSelected = this.tableItems.find(element => element.id === ids[0]);
            this.getUser(this.modals.order.caseSelected.client_contract_id, this.modals.order.caseSelected.location_id);
            this.modals.order.data.supplier = this.modals.order.caseSelected ? this.modals.order.caseSelected.supplier : null;
            this.modals.order.data.supplier_id = this.modals.order.caseSelected ? this.modals.order.caseSelected.supplier_id : null;
            this.modals.order.data.officer_in_charge_id = {
                user_id: this.modals.order.caseSelected ? this.modals.order.caseSelected.officer_in_charge_id : null,
                user_name: (this.modals.order.caseSelected && this.modals.order.caseSelected.user) ? this.modals.order.caseSelected.user.name : null,
                role_name: null
            }

            this.modals.order.open = true;
        },
        /*----------------------------------------*/
        exportCSV(tableRequest) {
            let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
            this.$store.dispatch('CaseManagementController/exportCsv',request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'CaseList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        showModalExportNLT() {
            this.modals.exportNLT.open = true;
            this.modals.exportNLT.data = {
                start_date: null,
                end_date: null
            }
        },
        async exportCaseNLT() {
            if(!this.modals.exportNLT.data.start_date) {
                return this.$alertNotification("Start date is required", "danger");
            }

            if(!this.modals.exportNLT.data.end_date) {
                return this.$alertNotification("End date is required", "danger");
            }

            if(moment(this.modals.exportNLT.data.start_date).isAfter(this.modals.exportNLT.data.end_date)) {
                return this.$alertNotification("Start date must be less than end date", "danger");
            }

            var st = moment(this.modals.exportNLT.data.start_date);
            var ed = moment(this.modals.exportNLT.data.end_date);
            var dayDiff = ed.diff(st, 'days');
            if(dayDiff>62) {
                return this.$alertNotification("Cannot export more than 2 months.", "danger");
            }

            // if(moment(this.modals.exportNLT.data.end_date).diff(moment(this.modals.exportNLT.data.start_date), 'months', true) > 1) {
            //     return this.$alertNotification("Date range no more than 1 month", "danger");
            // }

            const that = this;
            this.modals.exportNLT.process = 0;
            this.modals.exportNLT.open = false;
            this.modals.exportNLT.process = "Creating file export";
            this.modals.exportNLT.open_process = true;
            await global.axios('/api/cases/export-nlt', {
                method: "GET",
                params: {
                    isCMS: '1',
                    filter: {
                        client_contract_id: { type: "number", value: this.ClientContractID.id, function: "=", with: [] },
                        reported_time: { type: "date", value: [moment(new Date(this.modals.exportNLT.data.start_date)).format('YYYY-MM-DD'), moment(new Date(this.modals.exportNLT.data.end_date)).format('YYYY-MM-DD')], function: "<>", with: [] },
                        include_email: { type: "text", value: this.modals.exportNLT.data.include_email, function: "=", with: []}
                    },
                    contract_id: this.ClientContractID.id
                },
                responseType: 'blob',
                onDownloadProgress (progressEvent) {
                    that.modals.exportNLT.process = "Downloading";
                }
            })
                .then(response => {
                    // var nameFile = `report-${moment().format('DD-MMM-YYYY')}.zip`;
                    // const url = window.URL.createObjectURL(new Blob([response.data]));
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', nameFile); //or any other extension
                    // document.body.appendChild(link);
                    // link.click();
                    this.modals.exportNLT.loading = false;
                    this.modals.exportNLT.open_process = false;
                    this.modals.exportNLTMessage.open = true;
                }).catch(err => {
                    // this.modals.exportNLT.loading = false;
                })
        },
        /*---- Component event  (Save Data) ------------------------------------*/
        createRWO() {
            if (!this.modals.order.data.supplier_id) {
                return this.$alertNotification("Supplier is a required field.", "danger");
            }

            if (!this.modals.order.data.officer_in_charge_id) {
                return this.$alertNotification("FM Staff is a required field.", "danger");
            }
            if (this.modals.order.loading) return;

            let itemSelect = this.tableItems.filter(item => this.modals.order.ids.includes(item.id))

            let request = {
                type: "Case",
                item_id: itemSelect[0].id,
                supplier_id: this.modals.order.data.supplier_id,
                officer_in_charge_id: this.modals.order.data.officer_in_charge_id.user_id,
            };
            this.$store.dispatch(`OrderController/raiseOrder`, request)
                .then(response => {
                    this.$alertNotification(this.$notificationV2('adding', 'order'));
                    this.modals.order.loading = false;
                    this.modals.order.open = false;
                    this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(err => {
                    this.modals.order.loading = false;
                    this.$alertNotification("Can't create order", "danger");
                });
        },
        /*----------------------------------------*/
        rowClass(item, type) {
            if (item) {
                if (item.status === "Open") {
                    return 'row-case-new';
                }
            }
            return null;
        },
        updateDate(){
            var st = moment(this.modals.exportNLT.data.start_date);
            this.modals.exportNLT.data.min_end_date = new Date(st);
            this.modals.exportNLT.data.max_end_date = new Date(moment(st).add(62,'days'));
            this.modals.exportNLT.data.end_date = null;
        },
        hideRoleExportCaseNLT () {
            if(this.UserLogin && this.UserLogin.roles && this.UserLogin.roles.length > 0){
                const arrTmp = this.UserLogin.roles.filter(item => item.name.toUpperCase() == 'NLT CSO')
                if(arrTmp.length) {
                    return false;
                }
            }
            return true;
        }
    }
}
</script>
